import zhTW from './locales/zh-TW';
import enUS from './locales/en-US';
import jaJP from './locales/ja-JP';

const LOCALES = {
  'zh-TW': zhTW,
  'en-US': enUS,
  'ja-JP': jaJP
};

const STORAGE_KEY = 'mokugyo_language';

// 獲取瀏覽器語言
const getBrowserLanguage = () => {
  const lang = navigator.language || navigator.userLanguage;

  // 精確匹配
  if (LOCALES[lang]) {
    return lang;
  }

  // 匹配語言前綴 (例如: en-GB -> en-US)
  const langPrefix = lang.split('-')[0];
  const matchedLocale = Object.keys(LOCALES).find(key => key.startsWith(langPrefix));

  return matchedLocale || 'zh-TW'; // 預設中文
};

// 獲取當前語言
export const getCurrentLanguage = () => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved && LOCALES[saved]) {
      console.log('📖 讀取儲存的語言:', saved);
      return saved;
    }
  } catch (e) {
    console.warn('無法讀取語言設定:', e);
  }

  const browserLang = getBrowserLanguage();
  console.log('🌐 使用瀏覽器語言:', browserLang);
  return browserLang;
};

// 設定語言
export const setLanguage = (locale) => {
  if (!LOCALES[locale]) {
    console.warn(`不支援的語言: ${locale}`);
    return false;
  }

  try {
    localStorage.setItem(STORAGE_KEY, locale);
    console.log('💾 語言已儲存:', locale);
    return true;
  } catch (e) {
    console.warn('無法儲存語言設定:', e);
    return false;
  }
};

// 獲取翻譯文本
export const getTranslation = (key, locale) => {
  const lang = locale || getCurrentLanguage();
  const translations = LOCALES[lang];

  if (!translations) {
    console.warn(`找不到語言包: ${lang}`);
    return key;
  }

  // 支援巢狀路徑 (例如: 'common.close')
  const keys = key.split('.');
  let value = translations;

  for (const k of keys) {
    if (value && typeof value === 'object' && k in value) {
      value = value[k];
    } else {
      console.warn(`找不到翻譯: ${key}`);
      return key;
    }
  }

  return value;
};

// 🔧 修正:語言列表 - 添加英文名稱作為副標題
export const getAvailableLanguages = () => {
  return [
    {
      code: 'zh-TW',
      name: '繁體中文',
      nativeName: '繁體中文',
      englishName: 'Traditional Chinese'
    },
    {
      code: 'en-US',
      name: 'English',
      nativeName: 'English',
      englishName: 'English (US)'
    },
    {
      code: 'ja-JP',
      name: '日本語',
      nativeName: '日本語',
      englishName: 'Japanese'
    }
  ];
};

// 獲取當前語言的完整翻譯對象
export const getCurrentTranslations = () => {
  const lang = getCurrentLanguage();
  console.log('📚 獲取翻譯對象:', lang);
  return LOCALES[lang] || LOCALES['zh-TW'];
};

export default {
  getCurrentLanguage,
  setLanguage,
  getTranslation,
  getAvailableLanguages,
  getCurrentTranslations
};